import React from 'react';
import css from './EfficiencyPercentage.module.css';
import ElipsProgressbarIcon from '@modules/Landing/Shared/Icons/ElipsProgressbarIcon';
import ElipsProgressbarFillIcon from '@modules/Landing/Shared/Icons/ElipsProgressbarFillIcon';

export const EfficiencyPercentage: React.FC = () => (
    <div className={css.container}>
        <div className={css.progressBarContainer}>
            <div className={css.progressBar}>
                <span className={css.progress}>
                    <ElipsProgressbarIcon />
                </span>
                <span className={css.progressFill}>
                    {' '}
                    <ElipsProgressbarFillIcon />
                </span>
            </div>
            <span className={css.value}>80%</span>
        </div>
        <span className={css.text}>More efficient and time-saving</span>
    </div>
);
